import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ApiOrdersService} from "./api-orders.service";

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [ApiOrdersService]
})
export class ApiOrdersModule { }
